module.exports = __webpack_public_path__ + "static/media/image-5.2a67c07c.jpg";